import React from 'react'
import { FileIcon } from 'lucide-react'
import { isChatImageUrl, isChatVideoUrl } from '../../api/teamChat'

interface ChatMessageBodyProps {
  body: string
  attachmentUrl?: string | null
}

export function ChatMessageBody({ body, attachmentUrl }: ChatMessageBodyProps) {
  const showBody = Boolean(body?.trim())
  const url = attachmentUrl || null

  return (
    <div className="space-y-2">
      {url && isChatImageUrl(url) && (
        <a href={url} target="_blank" rel="noopener noreferrer" className="block">
          <img
            src={url}
            alt="Attachment"
            className="max-h-56 max-w-full rounded-lg border border-gray-200 object-contain bg-white"
          />
        </a>
      )}
      {url && isChatVideoUrl(url) && (
        <video
          src={url}
          controls
          className="max-h-56 max-w-full rounded-lg border border-gray-200 bg-black"
        />
      )}
      {url && !isChatImageUrl(url) && !isChatVideoUrl(url) && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800"
        >
          <FileIcon className="w-4 h-4" />
          Open attachment
        </a>
      )}
      {showBody && (
        <p className="text-sm text-gray-900 whitespace-pre-wrap break-words">{body}</p>
      )}
    </div>
  )
}
